export default function PatientProfileButton({
	link,
	text,
	theme = 'blue',
	closeModal = true,
}) {
	const closeModalAttrs = closeModal
		? { 'data-dissmiss': 'modal', 'data-bs-dissmiss': 'modal' }
		: {};
	return (
		<div className='col-12 col-lg-4'>
			<a
				href={link}
				className={'btn mt-3 w-100 btn-' + theme + '-global remastered'}
				{...closeModalAttrs}>
				{text}
			</a>
		</div>
	);
}
